import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { urlAssets } from '../../Constants';

const description = "Conoce qué selecciones tienen\n asegurada su plaza al Mundial de Qatar.";

const Passport = () => {
    return (
        <section className="mb-2 passport">
            <figure className="mb-0 text-center">
                <LazyLoadImage
                    alt={description}
                    className="img-fluid"
                    effect="blur"
                    src={`${urlAssets}/img/pasaporte.png`}
                />
            </figure>
            <figcaption className="text-center passport-desc">{description}</figcaption>
        </section>
    )
}

export default Passport;
